// import * as $ from 'jquery/dist/jquery.slim'
import{ AppClipsCapability, appClipsCapability } from '../Core'
import{ AppType, GLOBAL_AppPlatform, Metrics, Page, Platform, TriggerPoint } from '../Metrics'


// TODO(arch): is there a better/standard way to initialize this? (ie: encapsulate within class)
export function initActionBar( page:Page ){
	// init
	$('#__actionBar #actionBarCTA').on( 'click', async (e) => {
		let actionBarButton:HTMLElement = e.currentTarget
		
		let appType:AppType = (appClipsCapability == AppClipsCapability.Full) ? AppType.Transient : AppType.Permanent
		if( GLOBAL_AppPlatform == Platform.iOS ) // TEMP: workaround for Amplitude bug where filters are not respected when synching
			await Metrics.logNAV_launchApp( appType, page, TriggerPoint.PrimaryCTA )
	
		// navigate
		// A2
		let href:string = actionBarButton.getAttribute( 'data-href' )
		// console.debug( `CTA HREF: ${href}` )
		await Metrics.flush() // NOTE: ensure metrics are pushed before navigating away
		window.location.href = href
		// A1
		// if( appClipsCapability == AppClipsCapability.Full ){
		// 	// /*NOTE: ignore async*/await launchAppClip()
		// } else {
		// 	// /*NOTE: ignore async*/await launchApp()
		// }
	})
}
